import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const Message = styled.div``;

export const Links = styled.div`
	display: flex;
	gap: 12px;
`;

export const LinkAnchor = styled.a`
	color: ${({ theme }) => theme.blue[600]};
	text-decoration: underline;

	&:hover {
		color: ${({ theme }) => theme.blue[700]};
	}
`;

export const LinkButton = styled.button`
	padding: 0;
	background: none;
	border: none;
	color: ${({ theme }) => theme.blue[600]};
	text-decoration: underline;
	font: inherit;
	// Exception to the no-pointer-on-buttons rule: this <button> is visually an
	// inline text link and sits next to an <a> that gets pointer by default —
	// matching keeps the two links consistent.
	cursor: pointer;

	&:hover {
		color: ${({ theme }) => theme.blue[700]};
	}
`;
